import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui';

type Props = {
  onClick: () => void;
};

export const DeclineSubscriptionButton: React.FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    return () => {
      setLoading(false);
    };
  }, []);

  return (
    <Button
      data-testid="decline-subscription-button"
      loading={loading}
      onClick={() => {
        setLoading(true);
        onClick();
      }}
    >
      {t('workOrder.dontSubscribe', "Don't Subscribe")}
    </Button>
  );
};
